"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
class OrderConfigInstance {
    constructor(config) {
        // Extra options
        this.direction = 'asc';
        this.config = config;
    }
    clone() {
        const clon = new OrderConfigInstance(this.config);
        clon.direction = this.direction;
        return clon;
    }
    sortSamples(samples) {
        if (this.direction === 'manual') {
            return samples;
        }
        const order_f = (s) => {
            let option = s.retrieveValueForFilterOrGroup(this.config);
            if (this.config.type === 'date') {
                option = (0, moment_1.default)(option).valueOf();
            }
            return [
                option,
                s.code,
            ];
        };
        return (0, lodash_1.orderBy)(samples, order_f, this.direction);
    }
    toConfiguration() {
        return {
            config_name: this.config.name,
            direction: this.direction,
        };
    }
}
exports.default = OrderConfigInstance;
